import "./TermsAndConditions.module.css";
import Header from "@/reusable_sections/Header";
import TermsHeader from "./sections/TermsHeader";
import Terms from "./sections/Terms";
import Footer from "@/reusable_sections/Footer";
export default function TermsAndConditionsPage() {
  return <div>
      <Header />
      <TermsHeader />
      <Terms />
      <Footer />
    </div>;
}